import React from 'react'
import { Alert, Spin } from 'antd'
import './style.css'

const Loading =  ({loading}) => {
    return (
        loading ?
            <Alert
                className="loading"
                style={{zIndex:9999}}
                  message={<><Spin /> <span style={{marginLeft:5}}>Loading...</span></>}                  
                />
        :null      
    )
}

export default Loading